"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyHomeRoute = exports.MyHomeRouteDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var person_details_banner_1 = require("../../entities/person-details-banner");
var use_lang_1 = require("../../../hooks/use-lang");
var app_search_select_1 = require("../../app/app-search-select");
var app_recent_section_1 = require("../../app/app-recent-section");
var use_active_person_1 = require("../../../hooks/use-active-person");
var use_recent_list_1 = require("../../../hooks/use-recent-list");
var loading_layout_1 = require("../../elements/loading-layout");
var person_pinned_section_1 = require("../../entities/person-pinned-section");
var grid_1 = require("../../elements/grid");
var entity_count_chart_section_1 = require("../../entities/entity-count-chart-section");
var lodash_1 = require("lodash");
var use_entity_counts_1 = require("../../../hooks/use-entity-counts");
var use_home_pages_1 = require("../../../hooks/use-home-pages");
var content_entity_panel_1 = require("../../entities/content-entity-panel");
var app_latest_activity_section_1 = require("../../app/app-latest-activity-section");
var use_home_latest_activity_1 = require("../../../hooks/use-home-latest-activity");
var use_expertise_level_metrics_1 = require("../../../hooks/use-expertise-level-metrics");
var expertise_level_metrics_section_1 = require("../../entities/expertise-level-metrics-section");
var alert_message_1 = require("../../elements/alert-message");
var route_1 = require("../../../utils/route");
var use_app_routes_1 = require("../../../hooks/use-app-routes");
var use_entities_1 = require("../../../hooks/use-entities");
var current_path_name_1 = require("../../../utils/current-path-name");
var router_1 = require("@reach/router");
var app_participating_activites_section_1 = require("../../app/app-participating-activites-section");
var use_participating_activites_1 = require("../../../hooks/use-participating-activites");
var current_user_can_1 = require("../../../utils/current-user-can");
exports.MyHomeRouteDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0 ", " ", " ", ";\n  "], ["\n    padding: 0 ", " ", " ", ";\n  "])), theme_1.theme.UNIT(1), theme_1.theme.UNIT(2), theme_1.theme.UNIT(1)),
  desktop: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 0 ", " ", " ", ";\n  "], ["\n    padding: 0 ", " ", " ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3))
});
var RecentSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(5), theme_1.theme.UNIT(0), theme_1.theme.UNIT(2))
});
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border-bottom: none;\n  "], ["\n    border-bottom: none;\n  "])))
});
var SearchContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    cursor: text; \n    box-shadow: 0px 2px 1px inset rgba(0,0,0, 0.02);\n\n    &:focus-within {\n      border-color: ", ";\n    }\n  "], ["\n    padding: ", " ", " ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    cursor: text; \n    box-shadow: 0px 2px 1px inset rgba(0,0,0, 0.02);\n\n    &:focus-within {\n      border-color: ", ";\n    }\n  "])), theme_1.theme.UNIT(1.5), theme_1.theme.UNIT(0), theme_1.theme.UNIT(1.5, 2), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.COLOR('line-filter'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('primary'))
});
var PinnedItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n  "], ["\n    ", ";\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.H_DOT_BG_END('line-semi-subtle'), theme_1.theme.UNIT(8), theme_1.theme.UNIT(0)),
  desktop: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var CountSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PanelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LoadingStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    height: 40vh;\n    margin-top: ", ";\n  "], ["\n    height: 40vh;\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var LatestStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ExpertiseLevelsSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var ProfileAlertStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n    font-size: ", ";\n    cursor: pointer;\n\n    ", " {\n      margin-right: ", ";\n    }\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n    font-size: ", ";\n    cursor: pointer;\n\n    ", " {\n      margin-right: ", ";\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(15), alert_message_1.AlertMessage.cls.rule('icon'), theme_1.theme.UNIT(3))
});
var ParticipatingActivitesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    &:first-child {\n      margin-top: ", ";\n    }\n  "], ["\n    margin-bottom: ", ";\n    &:first-child {\n      margin-top: ", ";\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SearchContainer: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), SearchContainerStyles),
  Banner: (0, styled_components_1.default)(person_details_banner_1.PersonDetailsBanner)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  ProfileAlert: (0, styled_components_1.default)(alert_message_1.AlertMessage)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ProfileAlertStyles),
  Loading: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), LoadingStyles),
  Body: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  ParticipatingActivites: (0, styled_components_1.default)(app_participating_activites_section_1.AppParticipatingActivitesSection)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ParticipatingActivitesStyles),
  LatestSection: (0, styled_components_1.default)(app_latest_activity_section_1.AppLatestActivitySection)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), LatestStyles),
  CountSection: (0, styled_components_1.default)(entity_count_chart_section_1.EntityCountChartSection)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), CountSectionStyles),
  ExpertiseLevelsSection: (0, styled_components_1.default)(expertise_level_metrics_section_1.ExpertiseLevelMetricsSection)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ExpertiseLevelsSectionStyles),
  PinnedSection: (0, styled_components_1.default)(person_pinned_section_1.PersonPinnedSection)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), PinnedItemsStyles),
  RecentSection: (0, styled_components_1.default)(app_recent_section_1.AppRecentSection)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), RecentSectionStyles),
  Panel: (0, styled_components_1.default)(content_entity_panel_1.ContentEntityPanel)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), PanelStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
var MyHomeRoute = function (props) {
  var className = props.className;
  var t = (0, use_lang_1.useLang)();
  var from = (0, current_path_name_1.currentPathName)();
  var routes = (0, use_app_routes_1.useAppRoutes)();
  if (from === '/') {
    from = routes.homeReturn;
  }
  var entities = (0, use_entities_1.useEntities)();
  var activePerson = (0, use_active_person_1.useActivePerson)();
  var homePagesResult = (0, use_home_pages_1.useHomePages)();
  var recentListResult = (0, use_recent_list_1.useRecentList)();
  var recentList = recentListResult.query();
  var entityCountsResult = (0, use_entity_counts_1.useEntityCounts)();
  var expertiseMetricsResult = (0, use_expertise_level_metrics_1.useExpertiseLevelMetrics)();
  var homeLatestActivity = (0, use_home_latest_activity_1.useHomeLatestActivity)();
  var participatingActivities = (0, use_participating_activites_1.useParticipatingActivities)();
  var loading = recentList.loading || homePagesResult.loading || entityCountsResult.loading || expertiseMetricsResult.loading || homeLatestActivity.loading || participatingActivities.loading;
  var person = activePerson.person;
  var bio = person.bio,
    email = person.email,
    phone = person.phone,
    linkedin = person.linkedin,
    twitter = person.twitter,
    facebook = person.facebook,
    photo = person.photo,
    _a = person.challengeExpertise,
    challengeExpertise = _a === void 0 ? [] : _a,
    _b = person.topicExpertise,
    topicExpertise = _b === void 0 ? [] : _b,
    _c = person.keyIssueExpertise,
    keyIssueExpertise = _c === void 0 ? [] : _c,
    _d = person.sdgExpertise,
    sdgExpertise = _d === void 0 ? [] : _d,
    _e = person.subTopicExpertise,
    subTopicExpertise = _e === void 0 ? [] : _e;
  var hasExpertise = challengeExpertise.length || topicExpertise.length || keyIssueExpertise.length || sdgExpertise.length || subTopicExpertise.length;
  var editProfileRoute = (0, route_1.route)(entities.Profile.routes.update, {
    id: person && person.id,
    _trailing: "from".concat(from, "/")
  });
  var toSentence = function (words) {
    if (!words.length) {
      return '';
    }
    var lastWord = words.length > 1 ? " and ".concat(words.pop()) : '';
    return words.join(', ') + lastWord;
  };
  var parts = (0, lodash_1.filter)([!(bio && bio.text) && '**bio**', !(0, lodash_1.get)(photo, 'url') && '**photo**', !(email || phone || linkedin || twitter || facebook) && '**contact info**', !hasExpertise && '**expertise & interest**']);
  var message = "Help us build our community by **updating your profile** with your ".concat(toSentence(parts), ".");
  var showParticipatingActivites = process.env.SHOW_PARTICIPATING_ACTIVITIES === 'true';
  return react_1.default.createElement(My.Container, {
    className: className
  }, !!parts.length && react_1.default.createElement(My.ProfileAlert, {
    onClick: function () {
      return (0, router_1.navigate)(editProfileRoute);
    },
    text: t(message)
  }), (0, current_user_can_1.personCanReadHomeSection)(activePerson, 'search') && react_1.default.createElement(My.SearchContainer, null, react_1.default.createElement(app_search_select_1.AppSearchSelect, null)), loading ? react_1.default.createElement(My.Loading, null) : react_1.default.createElement(react_1.default.Fragment, null, showParticipatingActivites && react_1.default.createElement(My.ParticipatingActivites, {
    entity: participatingActivities.data
  }), react_1.default.createElement(My.Grid, {
    columns: 2,
    spacing: 2,
    items: [react_1.default.createElement(react_1.default.Fragment, null, (homePagesResult.pages || []).map(function (page) {
      return react_1.default.createElement(My.Panel, {
        key: page.id,
        entity: page
      });
    }), react_1.default.createElement(My.PinnedSection, {
      entity: person,
      title: "My Pins"
    }), (0, current_user_can_1.personCanReadHomeSection)(activePerson, 'latest-activity') && react_1.default.createElement(My.LatestSection, {
      items: homeLatestActivity.items
    }), /* personCanReadHomeSection(activePerson, 'recent-items') && */
    react_1.default.createElement(My.RecentSection, {
      items: recentList.results
    })), react_1.default.createElement(react_1.default.Fragment, null, (0, current_user_can_1.personCanReadHomeSection)(activePerson, 'platform-expertise') && react_1.default.createElement(My.ExpertiseLevelsSection, {
      items: (0, lodash_1.sortBy)(expertiseMetricsResult.expertiseLevels, 'orderNumber')
    }), (0, current_user_can_1.personCanReadHomeSection)(activePerson, 'platform-metrics') && react_1.default.createElement(My.CountSection, {
      items: entityCountsResult.items
    }))]
  })));
};
exports.MyHomeRoute = MyHomeRoute;
exports.MyHomeRoute.defaultProps = exports.MyHomeRouteDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30;